import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import api from 'middleware/api';
import rootReducer from 'reducers';

const configureStore = preloadedState => {
  const store = createStore(
    rootReducer,
    preloadedState,
    composeWithDevTools(applyMiddleware(thunk, api))
  );

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js